// The link facts of every active development (app-shell 2026-09-14, lever 5): what useLinkedDevsMap
// (Catalog cards' linked-dev counts, the catalog search's DA/DO/DS reverse lookup, the Originals
// Overview's linkage panel) and the Overview's stage / completed counts (isDevDone: full_status, stage, completedAt, stop_reason) read — eight fields, never the
// 50-column list. The bell's slim read (useDeadlineDevs) cannot serve this: it carries no link field
// and leaves out the 2,682 Done and stageless developments, which ARE linked to items and DO count
// in the Overview's Done bucket. Measured 2026-09-14: 4,706 rows / 3 pages / ~0.65 MB. Loaded only by
// the Catalog and the Overview; keyed UNDER ['developments'] so Tier A realtime invalidates it.
//
// Rows are flattened the way useAppData flattens the full list — the fields top-level AND under `data`,
// statuses normalised — so useLinkedDevsMap (d.based_on || d.data?.based_on, bod.item_id, d.dev_number),
// isDevDone (full_status) and the stage counts read them unchanged. updated_at is not carried: the
// map's per-item sort on it is unobserved by every consumer (they count and collect ids).
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../supabase';
import { fetchAllPaged } from '../utils/pgIn';
import { normalizeStatus, normalizeStageStatus } from '../shared';

export const DEV_LINKS_KEY = ['developments', 'links-slim'];
export const DEV_LINKS_SELECT = 'id,r:stop_reason,n:data->dev_number,s:data->stage_status,f:data->full_status,c:data->completedAt,b:data->based_on,i:data->based_on_data->item_id';

const flatten = (r) => {
  const data = { dev_number: r.n ?? null, stage_status: normalizeStageStatus(r.s), full_status: normalizeStatus(r.f), completedAt: r.c ?? null, based_on: r.b ?? null, based_on_data: r.i == null ? null : { item_id: r.i } };
  return { id: r.id, stop_reason: r.r ?? null, ...data, data };   // stop_reason is a column; isDevDone reads it and completedAt too
};

export async function fetchDevLinksSlim() {
  const rows = await fetchAllPaged(
    () => supabase.from('developments').select(DEV_LINKS_SELECT).is('deleted_at', null)
      .or('data->>archived.is.null,data->>archived.neq.true')                       // Conv #58: NULL is "not archived"
      .order('id'),
    { label: 'dev links-slim' }
  );
  return rows.map(flatten);
}

/** The active developments' link facts, slim — [] until read; loaded only when `enabled`. */
export function useDevLinksSlim(enabled = true) {
  const q = useQuery({ queryKey: DEV_LINKS_KEY, queryFn: fetchDevLinksSlim, enabled, staleTime: 5 * 60 * 1000, gcTime: 30 * 60 * 1000 });
  return q.data || EMPTY;
}
const EMPTY = [];
